import type { CategoryInfo } from "@/types/video";

export const categories: CategoryInfo[] = [
  {
    type: "movie",
    name: "电影",
    slug: "movie",
    icon: "ri-film-line",
    tagline: "海量热门电影资源",
    description: "院线大片、口碑佳作、独立影像一网打尽，覆盖动作、科幻、悬疑、爱情等多种题材。",
  },
  {
    type: "tv",
    name: "电视剧",
    slug: "tv",
    icon: "ri-live-line",
    tagline: "追剧党的聚宝盆",
    description: "都市情感、古装权谋、刑侦悬疑、热血青春，热门剧集持续更新，一追到底。",
  },
  {
    type: "variety",
    name: "综艺",
    slug: "variety",
    icon: "ri-mic-line",
    tagline: "欢乐不间断的综艺现场",
    description: "真人秀、音乐、脱口秀、美食、竞技综艺应有尽有，承包你的每一个周末夜晚。",
  },
];

export const categoryMap: Record<string, CategoryInfo> = {
  movie: categories[0],
  tv: categories[1],
  variety: categories[2],
};